// eslint-disable-next-line import/prefer-default-export
export const WorkplanPublishStepCode = Object.freeze({
    Loading: -1, // Only exists in FE
    PreparingData: 0,
    ShiftlineAssignations: 1,
    WorkplanRollout: 2,
    WrappingUp: 3,
});
